import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const ExpSpeaksPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.ExpertSpeaks}
        fetchRecordsUrl={AdminReqUrls.admin__expSpk__mainPage_fetch_recordList}
    />)
});
export default ExpSpeaksPage;
